//import React from "react";
/*import '../App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import MREGraph from "./Graph/MRE-Graph-Rover";

import React, { useRef } from 'react';


const Admin =({ darkMode }) =>{

    const NextRef = useRef(null);

  const scrollToNext = () => {
    
    NextRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

   return (

    <div className="home-wrapper">
    <div className ="container-fluid mt-4">

       
         <div  className="container-fluid scroll-target pt-5 mt-5">
         <MREGraph />  
        </div> 
                
    
    </div>
    </div>
   );
}
export default Admin;*/
import React from 'react';

export default function AdminPage() {
  return (
    <div style={{ margin: 0, padding: 0, overflow: 'hidden', height: '100vh' }}>
      <iframe
        src="https://data-extraction-xi.vercel.app/"
        width="100%"
        height="100%"
        style={{
          border: 'none',
          margin: 0,
          padding: 0,
          display: 'block',
          height: '100vh',
        }}
        title="Graph Dashboard"
      />
    </div>
  );
}

